import { VaultRole } from '@/modules/api/codegen';
import type { EntityWithPermissions } from '@/types';

import { permissionsToVaultRole } from './vaultRole';

interface VaultMembers {
    groups: EntityWithPermissions[];
    users: EntityWithPermissions[];
}

/**
 * The contract rejects an update that leaves a vault without an editor. Groups count: a vault whose only
 * editor is a group is legitimate, and a users-only check would block saving it.
 *
 * Only meaningful on edit — creating persists the caller as an editor whatever the form says.
 */
export const hasVaultEditor = ({ groups, users }: VaultMembers): boolean =>
    [...groups, ...users].some(({ accessPermissions }) => permissionsToVaultRole(accessPermissions) === VaultRole.editor);
